import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { recordLoginHistory } from "../api/loginHistoryApi";
import { logger } from "../utils/logger";

const SESSION_KEY = "loginHistorySent";

export const useLoginHistoryTracking = (): void => {
  const authUser = useSelector((state: RootState) => state.auth.user);
  const accessToken = useSelector((state: RootState) => state.auth.token);

  const inFlightRef = useRef(false);
  const sentRef = useRef(false);

  const isAuthenticated = Boolean(authUser && accessToken);

  useEffect(() => {
    if (!isAuthenticated) return;
    if (sentRef.current || inFlightRef.current) return;

    try {
      if (window.sessionStorage.getItem(SESSION_KEY) === "true") {
        sentRef.current = true;
        return;
      }
    } catch {
      // sessionStorage unavailable — proceed
    }

    inFlightRef.current = true;

    const payload = {
      lastLoggedAt: new Date().toISOString(),
      clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      clientTimeStamp: new Date().toISOString(),
      deviceType: "web",
    };

    recordLoginHistory(payload)
      .then(() => {
        sentRef.current = true;
        try {
          window.sessionStorage.setItem(SESSION_KEY, "true");
        } catch {
          // no-op
        }
      })
      .catch((error: any) => {
        logger.error("[LoginHistory] Failed to record login history", {
          status: error?.response?.status,
          message: error?.message,
        });
      })
      .finally(() => {
        inFlightRef.current = false;
      });
  }, [isAuthenticated]);
};
